
import React, { useEffect, useState } from "react";
import DetectorList from './DetectorList';
import Moment from 'react-moment';
import moment from 'moment';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import FolderIcon from '@mui/icons-material/Folder';
import DeleteIcon from '@mui/icons-material/Delete';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { red, green, blue, yellow } from '@mui/material/colors';
import BarChartIcon from '@mui/icons-material/BarChart';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { useParams } from "react-router-dom";
import MySimpleMap from '../components/map/MySimpleMap';
import RadarIcon from '@mui/icons-material/Radar';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import PinIcon from '@mui/icons-material/Pin';
import Battery90Icon from '@mui/icons-material/Battery90';
import Battery80Icon from '@mui/icons-material/Battery80';
import Battery60Icon from '@mui/icons-material/Battery60';
import Battery50Icon from '@mui/icons-material/Battery50';
import Battery30Icon from '@mui/icons-material/Battery30';
import Battery20Icon from '@mui/icons-material/Battery20';
import BatteryAlertIcon from '@mui/icons-material/BatteryAlert';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MailIcon from '@mui/icons-material/Mail';
import SignalWifi3BarIcon from '@mui/icons-material/SignalWifi3Bar';
import { setISODay } from "date-fns";
import AuthService from "../services/auth.service";

import authHeader from "../services/auth-header";
//import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
//import 'leaflet/dist/leaflet.css';
//import L from 'leaflet';
//import markerIconPng from "leaflet/dist/images/marker-icon.png"
//import {Icon} from 'leaflet'
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  root: {
    background: (props) =>
      props.color === 'red'
        ? 'linear-gradient(45deg, #FF0000 30%, #f26f8c 90%)'
        : 'linear-gradient(45deg, #008000 30%, #87eda2 90%)',
    border: 0,
    borderRadius: 3,
    boxShadow: (props) =>
      props.color === 'red'
        ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
        : '0 3px 5px 2px rgba(135, 237, 162, .3)',
    color: 'white',
    height: 48,
    padding: '0 30px',
    margin: 8,
    textAlign: 'center'
  },
  detectorItem: {
    background: (props) =>
      props.color === 'red'
      ? 'linear-gradient(45deg, #FF0000 10%, #f26f8c 90%)'
      : 'linear-gradient(45deg, #008000 10%, #87eda2 90%)',
    border: 1,
    borderRadius: 30,
    boxShadow: (props) =>
      props.color === 'red'
        ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
        : '0 3px 5px 2px rgba(135, 237, 162, .3)',
    color: 'white',
    textAlign: 'center'

  }
});
function renderIsBusyIcon(isBusyValue){
  if(isBusyValue === 1)
  {
     return(<Avatar sx={{ bgcolor: red[500] }}><TimeToLeaveIcon /></Avatar>)
  }
  else if(isBusyValue === 0)
  {
     return(<Avatar sx={{ bgcolor: green[500] }}><TimeToLeaveIcon /></Avatar>)
  }
  else {
     return(<Avatar sx={{ bgcolor: yellow[500] }}><TimeToLeaveIcon /></Avatar>)
  }
}
function renderBattIcon(batteryValue){
  var batteryPercentage = Math.round(100*(batteryValue/255));
  if(batteryPercentage >= 90)
  {
      return <Battery90Icon />
  }
  else if (batteryPercentage < 90 && batteryPercentage >= 80)
  {
    return <Battery80Icon />
  }
  else if (batteryPercentage < 80 && batteryPercentage >= 60)
  {
    return <Battery60Icon />
  }
  else if (batteryPercentage < 60 && batteryPercentage >= 50)
  {
    return <Battery50Icon />
  }
  else if (batteryPercentage < 50 && batteryPercentage >= 30)
  {
    return <Battery30Icon />
  }
  else if (batteryPercentage < 30 && batteryPercentage >= 20)
  {
    return <Battery20Icon />
  }
  else {
    return <BatteryAlertIcon />
  }
}

function Item1(props) {
  const { color, ...other } = props;
  const classes = useStyles(props);
  return <Paper variant="outlined"  elevation={24} className={classes.detectorItem} {...other} />;
}
function MyButton(props) {
  const { color, ...other } = props;
  const classes = useStyles(props);
  return <Button className={classes.root} {...other} />;
}

MyButton.propTypes = {
  color: PropTypes.oneOf(['blue', 'red']).isRequired,
};
Item1.propTypes = {
  color: PropTypes.oneOf(['blue', 'red']).isRequired,
};


const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    backgroundColor: red[500],
  },
  [theme.breakpoints.up('md')]: {
    backgroundColor: blue[500],
  },
  [theme.breakpoints.up('lg')]: {
    backgroundColor: green[500],
  },
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',

}));

const api = require("../api/names.js");

function renderLastFrameTime(lastFrameTime){
  if((Math.round(moment().unix() - lastFrameTime/1000)) >  86400)
  {
    //return <div>{moment.unix(lastFrameTime/1000).toNow(true)} (<Moment unix>{lastFrameTime/1000}</Moment>) - !!!Warning (>24h)!!! </div>;
    return <div>Last frame: {moment.unix(lastFrameTime/1000).toNow(true)}
     </div>;

  }
  else {
    //return <div>{moment.unix(lastFrameTime/1000).toNow(true)} (<Moment unix>{lastFrameTime/1000}</Moment>)</div>;
    return <div>Last frame: {moment.unix(lastFrameTime / 1000).toNow(true)} </div>;

  }
}
function renderFreeOrOcuupiedTime(detectorData){
  if(detectorData.detectorsCurrentValue.isBusy)
  {
    //return <div className="rowitem">Zajęty: {Math.round(moment().unix() - params.row.detectorsCurrentValue.entryTimestamp/1000)} s</div>;
    return <div>Occupied: {moment.unix(detectorData.detectorsCurrentValue.entryTimestamp/1000).toNow(true)}</div>;
  }
  else {
    //return <div className="rowitem">Wolny: {Math.round(moment().unix() - params.row.detectorsCurrentValue.exitTimestamp/1000)} s</div>;
    return <div>Free: {moment.unix(detectorData.detectorsCurrentValue.exitTimestamp/1000).toNow(true)}</div>;
    //moment([2007, 0, 29]).fromNow();
  }
}




function DetectorsByParkingTable(props) {

  const { t } = useTranslation("common");

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const [itemsBusy, setItemsBusy] = useState([]);
    const [itemsNotBusy, setItemsNotBusy] = useState([]);
    const [currentUser, setCurrentUser] = useState(true);
    const array1 = [];
    const params = useParams();
    //console.log(params);
    useEffect(() => {
      const user = AuthService.getCurrentUser();
      if (user) {
        setCurrentUser(user);
      }

      loadCurrentDataFromApi();
      const interval = setInterval(() => {
        loadCurrentDataFromApi();
      }, 50000);
    },[])

    function loadCurrentDataFromApi() {
      var url = api.baseUrl+'/detectorsEUIs/WithMetadataByParkingID/';
      url += params.parkingID;//props.parkingID;
      //console.log(url);
      fetch(url, {
    method: 'get',
    headers: authHeader()
    })
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);
          setIsLoaded(true);
          setItems(result);
          //var now = moment();
          //console.log(now);
          //array1 = result.map(result => result.radar = 1);
          //console.log(result.map(result => result.detectorsCurrentValue.updatedAt = new Date()));

        //  for(let i=0;i<items.lenght;i++)
        //  {


        //alert(items.filter(item => item.detectorsCurrentValue.isBusy = 1));
        //console.log(items.filter(item => item.detectorsCurrentValue.isBusy == 0));
        //setItemsNotBusy(items.filter(item => item.detectorsCurrentValue.isBusy == 0));
        //setItemsBusy(items.filter(item => item.detectorsCurrentValue.isBusy == 1));


        setItemsBusy(result.filter(item => item.detectorsCurrentValue.isBusy == 1));
        setItemsNotBusy(result.filter(item => item.detectorsCurrentValue.isBusy == 0));

        //console.log(itemsBusy);
        //console.log(itemsNotBusy);

        //  }
        //alert("sdsa");

        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )
    }

    const columnsDefault = [
    {
      field: 'isBusy',
      headerName: t('detectord.busy'),
      width: 80,
      renderCell: (params) => {
        return <div className="rowitem">{params.row.detectorsCurrentValue.isBusy}
        </div>;
      },
      valueGetter: (params) => params.row.detectorsCurrentValue.isBusy,
    },
    { field: 'address', headerName: t('detectord.address'), width: 70 },
    { field: 'eui', headerName: t('detectorsbp.eui'), width: 160 },

    {
      field: 'battery',
      headerName: t('detectorsbp.battery'),
      width: 260,
      renderCell: (params) => {
        if (params.row.detectorsCurrentValue.battery < 100) {
          return <div className="rowitem">{params.row.detectorsCurrentValue.battery}{t('detectorsbp.warbattery.1')}</div>;
        }
        else {
          return <div className="rowitem">{params.row.detectorsCurrentValue.battery}</div>;
        }

      },
      valueGetter: (params) => params.row.detectorsCurrentValue.battery,
    },
    {
      field: 'timestamp',
      headerName: t('detectorsbp.timestamp'),
      width: 400,
      renderCell: (params) => {
        if ((Math.round(moment().unix() - params.row.detectorsCurrentValue.timestamp / 1000)) > 86400) {
          return <div className="rowitem">{moment.unix(params.row.detectorsCurrentValue.timestamp / 1000).toNow(true)} (<Moment format="hh:mm:ss - DD/MM/YYYY" unix>{params.row.detectorsCurrentValue.timestamp / 1000}</Moment>) - {t('detectorsbp.wartimestamp')}</div>;

        }
        else {
          return <div className="rowitem">{moment.unix(params.row.detectorsCurrentValue.timestamp / 1000).toNow(true)} (<Moment format="hh:mm:ss - DD/MM/YYYY" unix>{params.row.detectorsCurrentValue.timestamp / 1000}</Moment>) </div>;

        }
      },
      valueGetter: (params) => moment.unix(params.row.detectorsCurrentValue.timestamp / 1000).format("HH:mm:ss - DD/MM/YYYY"),

    },
    {
      field: 'currentStateTime',
      headerName: t('detectorsbp.lastchange'),
      width: 230,
      renderCell: (params) => {
        if (params.row.detectorsCurrentValue.isBusy) {
          //return <div className="rowitem">Zajęty: {Math.round(moment().unix() - params.row.detectorsCurrentValue.entryTimestamp/1000)} s</div>;
          return <div className="rowitem">{t('detectorsbp.busy.1')}: {moment.unix(params.row.detectorsCurrentValue.entryTimestamp / 1000).toNow(true)}</div>;
        }
        else {
          //return <div className="rowitem">Wolny: {Math.round(moment().unix() - params.row.detectorsCurrentValue.exitTimestamp/1000)} s</div>;
          return <div className="rowitem">{t('detectorsbp.free.1')} {moment.unix(params.row.detectorsCurrentValue.exitTimestamp / 1000).toNow(true)}</div>;
          //moment([2007, 0, 29]).fromNow();
        }
      },

    },
    {
      field: 'detectorDetails',
      headerName: t('detectorsbp.detectorsdetails'),
      width: 200,
      renderCell: (params_tb) => {
        return <Button href={'/detectorDetails/' + params.parkingID + '/' + params_tb.row.address} color="inherit">{t('detectorsbp.his')}</Button>;
      },

    },
    ];

    const columns = [
      {
        field: 'isBusy',
        headerName: 'Is Busy',
        width: 100,
        renderCell: (params) => {
       return <div className="rowitem">{params.row.detectorsCurrentValue.isBusy}
            </div>;
     },
     valueGetter: (params) => params.row.detectorsCurrentValue.isBusy,

    },
      { field: 'address', headerName: 'Address', width: 90 },
      { field: 'eui', headerName: 'eui', width: 180 },

      {
        field: 'radar',
        headerName: 'radar',
        width: 150,
        renderCell: (params) => {
       return <div className="rowitem">{params.row.detectorsCurrentValue.radar}</div>;
        },
        valueGetter: (params) => params.row.detectorsCurrentValue.radar,

      },
      {
        field: 'x',
        headerName: 'x',
        width: 100,
        sortable: true,
        renderCell: (params) => {
       return <div className="rowitem">{params.row.detectorsCurrentValue.x}</div>;
        },
        valueGetter: (params) => params.row.detectorsCurrentValue.x,

      },
      {
        field: 'y',
        headerName: 'y',
        width: 100,
        renderCell: (params) => {
       return <div className="rowitem">{params.row.detectorsCurrentValue.y}</div>;
        },
        valueGetter: (params) => params.row.detectorsCurrentValue.y,

      },
      {
        field: 'battery',
        headerName: 'battery',
        width: 200,
        renderCell: (params) => {
          if(params.row.detectorsCurrentValue.battery < 100)
          {
            return <div className="rowitem">{params.row.detectorsCurrentValue.battery} - !!!Warning (battery low)</div>;
          }
          else {
            return <div className="rowitem">{params.row.detectorsCurrentValue.battery}</div>;
          }

        },
        valueGetter: (params) => params.row.detectorsCurrentValue.battery,

      },
      {
        field: 'temperature',
        headerName: 'tempreature',
        width: 100,
        renderCell: (params) => {
       return <div className="rowitem">{params.row.detectorsCurrentValue.temperature}</div>;
        },
        valueGetter: (params) => params.row.detectorsCurrentValue.temperature,

      },
      {
        field: 'timestamp',
        headerName: 'Last frame',
        width: 500,
        renderCell: (params) => {
          if((Math.round(moment().unix() - params.row.detectorsCurrentValue.timestamp/1000)) >  86400)
          {
            return <div className="rowitem">{moment.unix(params.row.detectorsCurrentValue.timestamp / 1000).toNow(true)} (<Moment unix>{params.row.detectorsCurrentValue.timestamp/1000}</Moment>) - !!!Warning (>24h)!!! </div>;

          }
          else {
            return <div className="rowitem">{moment.unix(params.row.detectorsCurrentValue.timestamp / 1000).toNow(true)} (<Moment unix>{params.row.detectorsCurrentValue.timestamp/1000}</Moment>) </div>;

          }
        },
        valueGetter: (params) => moment.unix(params.row.detectorsCurrentValue.timestamp / 1000).format("HH:mm:ss - DD/MM/YYYY"),

      },
      {
        field: 'entryTimestamp',
        headerName: 'Entry',
        width: 300,
        renderCell: (params) => {
       return <div className="rowitem"><Moment unix>{params.row.detectorsCurrentValue.entryTimestamp/1000}</Moment></div>;
        },
        valueGetter: (params) => moment.unix(params.row.detectorsCurrentValue.entryTimestamp / 1000).format("HH:mm:ss - DD/MM/YYYY"),

      },
      {
        field: 'exitTimestamp',
        headerName: 'Exit',
        width: 300,
        renderCell: (params) => {
       return <div className="rowitem"><Moment unix>{params.row.detectorsCurrentValue.exitTimestamp/1000}</Moment></div>;
        },
        valueGetter: (params) => moment.unix(params.row.detectorsCurrentValue.exitTimestamp / 1000).format("HH:mm:ss - DD/MM/YYYY"),

      },
      {
        field: 'currentStateTime',
        headerName: 'Current state time',
        width: 300,
        renderCell: (params) => {
          if(params.row.detectorsCurrentValue.isBusy)
          {
            //return <div className="rowitem">Zajęty: {Math.round(moment().unix() - params.row.detectorsCurrentValue.entryTimestamp/1000)} s</div>;
            return <div className="rowitem">Zajety: {moment.unix(params.row.detectorsCurrentValue.entryTimestamp / 1000).toNow(true)}</div>;
          }
          else {
            //return <div className="rowitem">Wolny: {Math.round(moment().unix() - params.row.detectorsCurrentValue.exitTimestamp/1000)} s</div>;
            return <div className="rowitem">Wolny: {moment.unix(params.row.detectorsCurrentValue.exitTimestamp / 1000).toNow(true)}</div>;
            //moment([2007, 0, 29]).fromNow();
          }
        },
      },
      {
        field: 'frameType',
        headerName: 'frameType',
        width: 100,
        renderCell: (params) => {
       return <div className="rowitem">{params.row.detectorsCurrentValue.frameType}</div>;
        },
        valueGetter: (params) => params.row.detectorsCurrentValue.frameType,

      },
      {
        field: 'stateChange',
        headerName: 'stateChange',
        width: 100,
        renderCell: (params) => {
       return <div className="rowitem">{params.row.detectorsCurrentValue.stateChange}</div>;
        },
        valueGetter: (params) => params.row.detectorsCurrentValue.stateChange,

      },
      {
        field: 'counter',
        headerName: 'counter',
        width: 100,
        renderCell: (params) => {
       return <div className="rowitem">{params.row.detectorsMetadatum.counter}</div>;
        },
        valueGetter: (params) => params.row.detectorsMetadatum.counter,

      },
      {
        field: 'sf',
        headerName: 'SF',
        width: 100,
        renderCell: (params) => {
       return <div className="rowitem">{params.row.detectorsMetadatum.dataRate}</div>;
        },
        valueGetter: (params) => params.row.detectorsMetadatum.dataRate,

      },
      {
        field: 'rssi',
        headerName: 'rssi',
        width: 100,
        renderCell: (params) => {
       return <div className="rowitem">{params.row.detectorsMetadatum.rssi}</div>;
        },
        valueGetter: (params) => params.row.detectorsMetadatum.rssi,

      },
      {
        field: 'snr',
        headerName: 'snr',
        width: 80,
        renderCell: (params) => {
          return <div className="rowitem">{params.row.detectorsMetadatum.snr}</div>;
        },
        valueGetter: (params) => params.row.detectorsMetadatum.snr,

      },
      {
        field: 'detectorDetails',
        headerName: 'detectorDetails',
        width: 200,
        renderCell: (params_tb) => {
       return <Button href={'/detectorDetails/'+params.parkingID+'/'+params_tb.row.address} color="inherit">History Chart</Button>;
        },
      },
    ];


    if (error) {
       return <div>Error: {error.message}</div>;
     } else {
       return (


         <div>






      {currentUser.id == 4 ? (
      <div style={{ height: 1000, width: '100%' }}>
      <DataGrid

        rows={items}
        columns={columns}
        pageSize={100}
        rowsPerPageOptions={[10]}
        checkboxSelection
        disableSelectionOnClick
        getRowId={(row) => row.address}
        components={{
          Toolbar: GridToolbar,
        }}
        localeText={{
          toolbarColumns: t('gridtoolbar.columns'),
          toolbarFilters: t('gridtoolbar.filters'),
          toolbarDensity: t('gridtoolbar.density'),
          toolbarExport: t('gridtoolbar.export')
        }}
      />
      </div>) :
      (<div style={{ height: 1000, width: '100%' }}>
        <DataGrid

          rows={items}
          columns={columnsDefault}
          pageSize={100}
          rowsPerPageOptions={[10]}
          checkboxSelection
          disableSelectionOnClick
          getRowId={(row) => row.address}

        />
      </div>)

      }









        </div>
       );
     }
   }

export default DetectorsByParkingTable;
